import React from "react";
import { connect } from "react-redux";
import $ from "jquery";
import { toast } from "react-toastify";

class SendCode extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      phoneNumber: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    localStorage.clear();
    $(document).ready(function () {
      $("#vmc-form-link").click(function (e) {
        $("#vmc-form").delay(100).fadeIn(100);
        $("#nonvmc-form").fadeOut(100);
        $("#nonvmc-form-link").removeClass("active");
        $('#non-vmc').addClass("non-vmc");
        $('#vmc').removeClass("vmc")
        $(this).addClass("active");
        e.preventDefault();
      });
      $("#nonvmc-form-link").click(function (e) {
        $("#nonvmc-form").delay(100).fadeIn(100);
        $("#vmc-form").fadeOut(100);
        $("#vmc-form-link").removeClass("active");
        $('#non-vmc').removeClass("non-vmc");
        $('#vmc').addClass("vmc")
        $(this).addClass("active");
        e.preventDefault();
      });
    });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    const { phoneNumber } = this.state;
    if (this.state.phoneNumber === "") {
      toast.error("Please enter Phone Number");
    } else {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ phoneNumber })
      };
      let url = "http://15.206.132.121:3002/api/sendOTP";
      return fetch(url, requestOptions)
        .then(response => response.json())
        .then((res) => {
          if (!res.success) {
            throw res.message
          }
          let result = window.confirm("Have you recieved OTP? Click Ok else Cancel and retry again!");
          if (result) {
            this.props.history.push({ pathname: '/login/resetPassword', state: { data: `${res.data.code}` } })
          } else {
            window.location.reload();
          }
        })
        .catch(err =>
          toast.error("Please Try again", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          })
        );
    }
  }

  render() {
    const { phoneNumber } = this.state;
    return (
      <div>
        <div className="login-body">
          <div className="container ">
            <div className="logo" style={{ textAlign: "center" }}>
              <img
                src="https://www.vidyamandir.com/assets/images/vmc_logo.png"
                alt="VidyaMandir"
                style={{ marginTop: "3%", backgroundColor: "#1FB5AD" }}
              />
            </div>
            <div className="row">
              <div
                className="panel-heading"
                style={{
                  maxWidth: "330px",
                  height: "42px",
                  margin: "100px auto",
                  marginTop: "60px",
                  marginBottom: "-1px",
                  padding: '0'
                }}>
                <div style={{
                  height: "100%"
                }}>
                  <div style={{
                    height: "100%",
                    display: 'flex',
                    border: '2px solid darkgray',
                    borderBottom: 0

                  }}>
                    {/* <div className="form-flex" id="vmc">
                      <a
                        className="active"
                        id="vmc-form-link"
                        style={{
                          display: "flex",
                          justifyContent: "center"
                        }}>
                        <strong>VMC Student</strong>
                      </a>
                    </div>
                    <div className="form-flex non-vmc" id="non-vmc"
                    >
                      <a id="nonvmc-form-link">
                        <strong>Non-VMC Student</strong>
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
              <form
                className="form-signin"
                id="vmc-form"
                style={{ display: "block", marginTop: "0" }}
                onSubmit={this.handleSubmit}>
                <div>
                  <h2
                    className="form-signin-heading text-capital-none"
                    style={{ borderRadius: 0 }}>
                    Please enter Phone number to recieve OTP to reset Password.
                  </h2>
                </div>
                <div className="login-wrap">
                  <div className="user-login-info">
                    <input
                      type="text"
                      className="form-control fixed-height"
                      name="phoneNumber"
                      placeholder="Enter Phone Number"
                      value={phoneNumber}
                      onChange={this.handleChange}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-lg btn-login btn-block">
                    <strong>Send Code</strong>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const connectedSendCode = connect()(SendCode);
export { connectedSendCode as SendCode };